export default __webpack_public_path__ + "static/media/Venkatsh.21d165eb.png";